import { types } from 'mobx-state-tree';


const QuoteAllocationPriority = types
    .model('QuoteAllocationPriority', {
        insurer: types.string,
        providers: types.array(types.string),
    });

export default QuoteAllocationPriority;
